module.exports = __webpack_public_path__ + "static/media/loading.3d035a55.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/loading.gif
// module id = 617
// module chunks = 1